import { PROJECTS_VIEW_KEY } from './constants'
import type { ProjectsView } from './types'

const isProjectsView = (value: unknown): value is ProjectsView =>
  value === 'grid' || value === 'list'

// The chosen layout outlives the page: switching to rows once means rows next
// time as well. It is the same on every workspace of this browser.
// Storage can be off limits (Safari private mode, disabled site data) and then
// getItem/setItem throw: the switcher still works, the choice just does not
// survive a reload.
//
// localStorage here is a stopgap agreed in OCT-5064, not a pattern to copy:
// per CLAUDE.md a browser-storage preference is a red flag, and this one is
// meant to move to the account settings on the backend (next to dateFormat /
// timeFormat) once there is a place for it. Keep it isolated in this file.
export const readProjectsView = (): ProjectsView => {
  try {
    const stored = localStorage.getItem(PROJECTS_VIEW_KEY)

    return isProjectsView(stored) ? stored : 'grid'
  } catch {
    return 'grid'
  }
}

export const saveProjectsView = (view: ProjectsView): void => {
  try {
    localStorage.setItem(PROJECTS_VIEW_KEY, view)
  } catch {
    // хранилище недоступно — режим живёт до перезагрузки страницы
  }
}
